import { isCfaRentOrLease } from "./quote";
import { CC_BW_DISCOUNT, CC_COLOR_DISCOUNT, IS_NZ, SAAS_DISCOUNT, OPPORTUNITY_TYPES_NO_DISCOUNT } from "../../constants";
import {trim} from "lodash-es";

// region Non-MSA options
export const isCcBwValid = state =>
{
  //SPARK-1417 - just keeping the code by returning true if business want the validation back in the future
  return true;

  if(hasSelectionsUnderWarranty(state)){
    return true;
  }

  if(state.quote.isMsa) {
    return true;
  }

  //click charges could have fallback MSP with comma separated value.
  //If fallback exists, click charge couldn't lower than fallback value.
  if(state.product.hasFallbackCcBw){
    return state.product.ccBw >= state.product.defaultCcBw;
  }else{
    return state.product.ccBw >= state.product.defaultCcBw * CC_BW_DISCOUNT;
  }
}

export const isCcColourValid = state =>
{
  //SPARK-1417 - just keeping the code by returning true if business want the validation back in the future
  return true;
  
  if(hasSelectionsUnderWarranty(state)){
    return true;
  }

  if(state.quote.isMsa) {
    return true;
  }

  if(state.product.hasFallbackCcColour){
    return state.product.ccColour >= state.product.defaultCcColour
  }else{
    return state.product.ccColour >= state.product.defaultCcColour * CC_COLOR_DISCOUNT
  }
}

export const getCcBwInvalidErr = state =>
{
  if(state.product.hasFallbackCcBw){
    return `B&W Click Charges cannot be lower than MSP.`
  }else{
    return `B&W Click Charges cannot be lower than ${CC_BW_DISCOUNT * 100}% of the MSP.`
  }
}

export const getCcColourInvalidErr = state =>
{
  if(state.product.hasFallbackCcBw){
    return `Colour Click Charges cannot be lower than MSP.`
  }else{
    return `Colour Click Charges cannot be lower than ${CC_COLOR_DISCOUNT * 100}% of the MSP.`
  }
}
  

export const isScanChargeValid = state =>
  hasSelectionsUnderWarranty(state)
  || state.product.scanCharge >= state.product.defaultScanCharge
  || state.quote.isMsa;

export const isFlatMonthlyChargeValid = ({ product }) => {
  if(!IS_NZ) return product.flatMonthlyCharge === product.defaultFlatMonthlyCharge
  return product.flatMonthlyCharge === null || (product.flatMonthlyCharge >= 0 && product.flatMonthlyCharge <= product.defaultFlatMonthlyCharge)
}

export const isNzScanningMonthlyChargeValid = ({ product }) => {
  if(!IS_NZ) return product.nzScanningMonthlyCharge === null
  return product.defaultNzScanningMonthlyCharge === null || (product.nzScanningMonthlyCharge >= 0 && product.nzScanningMonthlyCharge <= product.defaultNzScanningMonthlyCharge)
}
export const isMinimumMonthlyChargeValid = ({ product }) => {
  if(!IS_NZ) return product.minimumMonthlyCharge === null
  return product.minimumMonthlyCharge === null || (product.minimumMonthlyCharge >= 0 && product.minimumMonthlyCharge <= product.defaultMinimumMonthlyCharge)
}
export const isTonerDeliveryChargeValid = ({ product }) => {
  if(!IS_NZ) return product.tonerDeliveryCharge === null
  return product.tonerDeliveryCharge === null || (product.tonerDeliveryCharge >= 0 && product.tonerDeliveryCharge <= product.defaultTonerDeliveryCharge)
}
export const isPerA3ChargeValid = ({ product }) => {
  if(!IS_NZ) return product.perA3Charge === null
  if(product.defaultPerA3Charge === null) return true;

  const a3Item = product.defaultPerA3Charge.find(item => {
    return item.hasOwnProperty(product.perA3Charge)
  })
  return a3Item !== undefined
}

export const areChargesValid = state => {
  const isSaas = state.product.customAttributes.reduce((value, attr) => attr.attribute_code === "is_bundle_saas" ? attr.value : value, "") === "1";
  if(isSaas) {
    return isTenantValid(state)
  }
  const clickValid = isCcBwValid(state) && isCcColourValid(state) && isScanChargeValid(state) && isFlatMonthlyChargeValid(state)
  if(!IS_NZ) return clickValid;
  return (
    clickValid 
    && isNzScanningMonthlyChargeValid(state) 
    && isMinimumMonthlyChargeValid(state) 
    && isTonerDeliveryChargeValid(state) 
    && isPerA3ChargeValid(state)
  )
}

export const hasCharges = ({ product }) =>
  product.defaultCcBw ||
  product.defaultCcColour ||
  product.defaultScanCharge ||
  product.scanningMonthlyCharge ||
  product.flatMonthlyCharge ||
  product.nzScanningMonthlyCharge ||
  product.minimumMonthlyCharge ||
  product.tonerDeliveryCharge ||
  product.perA3Charge;
// endregion

// region: MSA options
export const isMsaTermValidForRentOrLease = state =>
  !state.quote.isMsa ||
  (state.product.msaTerm >= state.product.msaDefaultTerm &&
    state.product.msaTerm >= 1 &&
    state.product.msaTerm <= 60) ||
  !isCfaRentOrLease(state);

export const isMsaCfaValidForRentOrLease = state =>
  !state.quote.isMsa ||
  (state.product.msaCfa >= state.product.msaDefaultCfa &&
    state.product.msaCfa >= 1 &&
    state.product.msaCfa <= 1000) ||
  !isCfaRentOrLease(state);

export const isMsaMdsCostValid = ({ product, quote }) =>
  !quote.isMsa ||
  product.msaMdsCost === 0 ||
  (product.msaMdsCost >= 1 && product.msaMdsCost <= 100000);

export const isMsaDefaultTermConfiguredForRentOrLease = state =>
  !state.quote.isMsa ||
  state.product.msaDefaultTerm > 0 ||
  !isCfaRentOrLease(state);

export const isMsaDefaultCfaConfiguredForRentOrLease = state =>
  !state.quote.isMsa ||
  state.product.msaDefaultCfa > 0 ||
  !isCfaRentOrLease(state);

export const isMsaPriceFlagConfigured = state =>
  !state.quote.isMsa || hasSelectionsUnderWarranty(state) || state.product.msaPriceFlag !== "";

export const isWarrantyProductRequired = state => {
  const warrantySkus = skusUnderWarranty(state);

  return  !(
    ( state.quote.isMsa ? areMsaClickChargesConfigured(state) : hasCharges(state) )
    && (
      state.product.availableOptions
        .filter( o => o.required === '1')
        .some( o => o.selections.every( s => warrantySkus.includes(s.product.sku) ))
    )
  );
};

export const hasSelectionsUnderWarranty = state => {
  return state.product.pickedOptionSelections.some(o => o.selections.some(s => skusUnderWarranty(state).includes(s.sku)));
};

export const skusUnderWarranty = ({ product }) => {
  //get warranty skus object
  const warrantySkus = product.customAttributes
    .find( a => a.attribute_code === 'skus_under_warranty');
  //get array of warranty skus
  return  typeof warrantySkus !== 'undefined' && warrantySkus.hasOwnProperty('value') && warrantySkus.value ?
    warrantySkus.value.split(',').map( s => trim(s)).filter( s => s !== '')
    : [];
};

export const isMsaPayableMethodConfigured = state =>
  !state.quote.isMsa ||
  state.product.msaPayableMethod !== "" ||
  !isCfaRentOrLease(state);

export const isMsaInstalmentFrequencyConfigured = state =>
  !state.quote.isMsa ||
  state.product.msaInstalmentFrequency !== "" ||
  !isCfaRentOrLease(state);

export const areMsaClickChargesConfigured = state => {
  const { quote, product } = state;
  return !quote.isMsa ||
    hasSelectionsUnderWarranty(state) ||
    (product.msaMetroClickChargeBw && product.msaMetroClickChargeColour) ||
    (product.msaRegionalClickChargeBw && product.msaRegionalClickChargeColour);
};

export const areMsaOptionsValid = state =>
  isMsaTermValidForRentOrLease(state) &&
  isMsaCfaValidForRentOrLease(state) &&
  isMsaMdsCostValid(state) &&
  isMsaDefaultTermConfiguredForRentOrLease(state) &&
  isMsaDefaultCfaConfiguredForRentOrLease(state) &&
  isMsaPriceFlagConfigured(state) &&
  isMsaPayableMethodConfigured(state) &&
  isMsaInstalmentFrequencyConfigured(state) &&
  areMsaClickChargesConfigured(state);
// endregion

export const customOptionValidationMessages = state =>
  [
    {
      isValid: isCcBwValid(state),
      message: getCcBwInvalidErr(state)
    },
    {
      isValid: isCcColourValid(state),
      message: getCcColourInvalidErr(state)
    },
    {
      isValid: isScanChargeValid(state),
      message: "Scan Charges cannot be lower than the MSP."
    },
    {
      isValid: isMsaDefaultTermConfiguredForRentOrLease(state),
      message:
        'The MSA account-specific "Term" is not configured. Please contact the product marketing team for the configuration.'
    },
    {
      isValid: isMsaDefaultCfaConfiguredForRentOrLease(state),
      message:
        'The MSA account-specific "CF per thousand" is not configured. Please contact the product marketing team for the configuration.'
    },
    {
      isValid: isMsaPriceFlagConfigured(state),
      message:
        'The MSA account-specific "Price Flag" is not configured. Please contact the product marketing team for the configuration.'
    },
    {
      isValid: isMsaPayableMethodConfigured(state),
      message:
        'The MSA account-specific "Payable Method" is not configured. Please contact the product marketing team for the configuration.'
    },
    {
      isValid: isMsaInstalmentFrequencyConfigured(state),
      message:
        'The MSA account-specific "Instalment Frequency" is not configured. Please contact the product marketing team for the configuration.'
    },
    {
      isValid: isMsaTermValidForRentOrLease(state),
      message: `The "Term" should be a integer between ${state.product.msaDefaultTerm} and 60.`
    },
    {
      isValid: isMsaCfaValidForRentOrLease(state),
      message: `The "CF per Thousand" should between ${state.product.msaDefaultCfa} and 1000.`
    },
    {
      isValid: isMsaMdsCostValid(state),
      message: 'The "MDS Cost" should between 1 and 100000.'
    },
    {
      isValid: areMsaClickChargesConfigured(state),
      message:
        "B&W & Colour Click Charges need to be configured for either Metro or Regional. Please contact the product marketing team for the configurations."
    },
    {
      isValid: isWarrantyProductRequired(state),
      message: "Click Charges have been setup but are not available to select, as Warranty is configured as a Required product option"
    },
    {
      isValid: isMinimumMonthlyChargeValid(state),
      message: `Minimum Monthly Charges must be between $0 and $${state.product.defaultMinimumMonthlyCharge}`
    },
    {
      isValid: isNzScanningMonthlyChargeValid(state),
      message: `Scanning Monthly Charge must be between $0 and $${state.product.defaultNzScanningMonthlyCharge}`
    },
    {
      isValid: isTonerDeliveryChargeValid(state),
      message: `Toner Delivery Charge must be between $0 and $${state.product.defaultTonerDeliveryCharge}`
    },
    {
      isValid: isPerA3ChargeValid(state),
      message: "Invalid selected item for Per A3 Charge"
    },
    {
      isValid: isFlatMonthlyChargeValid(state),
      message: `Flat Monthly Charges must be between $0 and $${state.product.defaultFlatMonthlyCharge}`
    }
  ]
    .filter(item => !item.isValid)
    .map(item => item.message);

export const isTenantValid = state => {
  var existing = state.product.customAttributes.reduce((value, attr) => attr.attribute_code === "bundle_saas_type" ? attr.value : value, "") === "existing";
  if(existing)
  {
    return trim(state.product.saasExistingTenant) !== ""
  }
  return true;
}

export const hasSaas = state => {
  var saasOptions = state.product.pickedOptionSelections.flatMap(
    sel => sel.selections.filter(
      opt => opt.isSaas
    )
  )
  //because the "Main Unit" is SaaS, we need more than 1 to satisfy this validation
  return saasOptions.length > 1
}

const hasSaasFinanceTypes = state =>
{
  return state.product.customAttributes.reduce((value, attr) => attr.attribute_code === "bundle_saas_finance_type" ? attr.value : value, "") !== "";
}

const saasTargetTotalsValid = state => {
  var isAllValid = true;
  state.product.pickedOptionSelections
    .flatMap(option => option.selections)
    .filter(selection => selection.isSaas)
    .forEach(selection => { 
      if(!saasTargetTotalValid(state.opportunity.OpportunityType, selection)) {
        isAllValid = false;
      }
    })
  return isAllValid
}
const saasTargetTotalValid = (OpportunityType, selection) => {
  return OPPORTUNITY_TYPES_NO_DISCOUNT.includes(OpportunityType) 
    ? selection.targetPrice === selection.price
    : selection.targetPrice >= selection.price * SAAS_DISCOUNT;
}

export const customSaasOptionValidationMessages  = state =>
[
  {
    isValid: isTenantValid(state),
    message: `Existing Tenant ID must be set`
  },
  {
    isValid: hasSaas(state),
    message: `SaaS bundle must have at least 1 SaaS selection`
  },
  {
    isValid: saasTargetTotalsValid(state),
    message: "Target Total on a SaaS item is invalid"
  },
  {
    isValid: hasSaasFinanceTypes(state),
    message: "The current bundle cannot be sold with this Finance Type / Subtype"
  }
]
  .filter(item => !item.isValid)
  .map(item => item.message);

  export const areSaasOptionsValid = state =>
    isTenantValid(state) &&
    hasSaas(state) &&
    saasTargetTotalsValid(state) &&
    hasSaasFinanceTypes(state);